import { JobMode } from '../../../interfaces/job-mode';

export function getJobModeValue(jobMode: JobMode) {
  return jobMode?.virtualValue || jobMode?.value;
}

export function getRecommendedJobMode(jobModes: JobMode[]) {
  return (jobModes || []).find(mode => mode.isRecommended);
}
